/**
 * Feature flag registry maintained in DataManager.
 * Provides a single source of truth for gating experimental features.
 */
const DEFAULT_FLAGS = Object.freeze({
  responsiveLayout: true,
  googleCalendarRead: false,
  googleCalendarWrite: false,
  analyticsInstrumentation: false,
  focusMode: true, // Focus mode with sidebar launcher and panels (DEFAULT!)
});

export class FeatureFlags {
  constructor(dataManager) {
    this.data = dataManager;
    this.storageKey = '_featureFlags';

    const stored = this.data?.get(this.storageKey, {});
    this.flags = {
      ...DEFAULT_FLAGS,
      ...(stored || {}),
    };

    // Persist merged defaults so the UI can inspect flag states.
    this.persist();
  }

  all() {
    return { ...this.flags };
  }

  isEnabled(flagName) {
    return Boolean(this.flags[flagName]);
  }

  set(flagName, value) {
    this.flags[flagName] = Boolean(value);
    this.persist();
  }

  persist() {
    if (!this.data?.set) return;
    this.data.set(this.storageKey, { ...this.flags });
  }
}

FeatureFlags.DEFAULTS = DEFAULT_FLAGS;
